<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/dashboardCalendar.svg" class="h-20px w-20px ml-1" />  {{'ProductivityBars' | localize}}
        </h5>

    </div>

    <div class="card-body">
        <div>
            <activities-productivity-bar [userId]="getUserId()"
                                         [tenantId]="getTenantId()"
                                         [passMinute]="5" (OfflineTimeAdded)="RefreshProd($event)"
                                         [startTime]=ProductiveBarStartTime
                                         [endTime]="ProductiveBarEndTime">

            </activities-productivity-bar>
        </div>

    </div>


</div>
